"use client";

import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious, type CarouselApi } from "@/components/ui/carousel";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const carouselImages = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577832/img/dZHCQQgV-4Kk8y_HS4Swn.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577832/img/dZHCQQgV-4Kk8y_HS4Swn.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577832/img/dZHCQQgV-4Kk8y_HS4Swn.png-wvc-sizes",
  alt: "European and Indian business professionals collaborating on trade agreements"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577832/img/UDwhM6t47ArPlzPKU9ynQ.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577832/img/UDwhM6t47ArPlzPKU9ynQ.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577832/img/UDwhM6t47ArPlzPKU9ynQ.png-wvc-sizes",
  alt: "Modern logistics and shipping port facility handling international cargo"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577832/img/mWKW5DcDZROV84vfCb5Nt.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577832/img/mWKW5DcDZROV84vfCb5Nt.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577832/img/mWKW5DcDZROV84vfCb5Nt.png-wvc-sizes",
  alt: "High-tech manufacturing plant interior representing industrial cooperation"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577832/img/E3ycxwaZ7W9zm6ys8n1_g.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577832/img/E3ycxwaZ7W9zm6ys8n1_g.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577832/img/E3ycxwaZ7W9zm6ys8n1_g.png-wvc-sizes",
  alt: "Global trade network digital visualization connecting Europe and India"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577832/img/PljMUcQzdcCLq5ob3d9MO.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577832/img/PljMUcQzdcCLq5ob3d9MO.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577832/img/PljMUcQzdcCLq5ob3d9MO.png-wvc-sizes",
  alt: "Commercial cargo plane loading freight for cross-border transport"
}];
export default function AutoRotatingImageSlider() {
  const [api, setApi] = React.useState<CarouselApi>();
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  React.useEffect(() => {
    if (!api) {
      return;
    }
    const intervalId = setInterval(() => {
      api.scrollNext();
    }, 5000);
    return () => clearInterval(intervalId);
  }, [api]);
  return <section id="autorotatingimageslider" className="bg-background">
      <div className="bg-primary text-primary-foreground py-16 md:py-24 overflow-hidden">
        <div ref={ref} className={`container mx-auto px-4 md:px-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="max-w-6xl mx-auto relative">
            <Carousel opts={{
            loop: true,
            align: "center"
          }} setApi={setApi} className="w-full">
              <CarouselContent>
                {carouselImages.map((image, index) => <CarouselItem key={index} data-index={index}>
                    <div className="p-1">
                      <div className="overflow-hidden rounded-lg border border-primary-foreground/10 shadow-xl bg-background/5">
                        <AspectRatio ratio={16 / 9}>
                          <img src={image.src} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} alt={image.alt} loading={index === 0 ? "eager" : "lazy"} className="object-contain w-full h-full transition-transform duration-700 hover:scale-105" />
                        </AspectRatio>
                      </div>
                    </div>
                  </CarouselItem>)}
              </CarouselContent>
              <div className="hidden md:block">
                <CarouselPrevious className="left-4 lg:-left-12 bg-background/10 border-primary-foreground/20 text-primary-foreground hover:bg-background/20 hover:text-primary-foreground backdrop-blur-sm" />
                <CarouselNext className="right-4 lg:-right-12 bg-background/10 border-primary-foreground/20 text-primary-foreground hover:bg-background/20 hover:text-primary-foreground backdrop-blur-sm" />
              </div>
            </Carousel>
            
            {}
            <div className="flex justify-center gap-2 mt-6 md:hidden">
              {carouselImages.map((_, index) => <div key={index} data-index={index} className="size-2 rounded-lg bg-primary-foreground/20" />)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}